import { useCallback, useMemo, useState } from "react"

import { GridRowId } from "@mui/x-data-grid"
import { ArticleResult, useListArticleBySearch } from "interface/article"
import { SearchDetailResult } from "interface/search"

import { Grid, useGrid } from "components/grid"
import { useArticleGridColumns } from "./columns"

import { KojinPreviewDialog } from "features/kojin/dialog/preview"
import { useKojinPreviewDialog } from "features/kojin/dialog/preview/hooks"
import { ArticlePreviewDialog } from "features/article/dialog/preview"

type ArticlePageProps = {
	search: SearchDetailResult
} & ReturnType<typeof useGrid>
export const ArticlePage = ({
	search,
	...others
}: ArticlePageProps) => {
	const { kojinCode, authorId, close } = useKojinPreviewDialog()
	const [selectedArticle, setSelectedArticle] = useState<ArticleResult | null>(null)

	const listState = useListArticleBySearch(search.searchId, { updateTime: search.updateTime })
	const progress = useMemo(
		() => listState.loaded && listState.total ? (listState.loaded / listState.total) * 100 : undefined,
		[listState]
	)
	const onClickLink = useCallback(
		(id: GridRowId) => setSelectedArticle(listState.data?.at(id as number) ?? null),
		[setSelectedArticle, listState]
	)
	const { columnsDef } = useArticleGridColumns({ onClickLink })
	return (
		<>
			<Grid
				{...others}
				saveKey="article_grid"
				baseFileName={search.title}
				sheetName="論文"
				loading={listState.loading}
				progress={progress}
				columnsDef={columnsDef}
				dataList={listState.data ?? []}
				onDblClick={setSelectedArticle}
			/>
			{(kojinCode || authorId) ? (
				<KojinPreviewDialog
					kojinCode={kojinCode ?? undefined}
					authorId={authorId ?? undefined}
					onClose={close}
				/>
			) : selectedArticle ? (
				<ArticlePreviewDialog
					article={selectedArticle}
					onClose={() => setSelectedArticle(null)}
				/>
			) : <></>}
		</>
	)
}